module.exports = __webpack_public_path__ + "img/36.11c8886d.jpg";